import React from "react"

import Layout from "../../components/layout"
import Header from "../../components/header"
import Footer from "../../components/footer"
import Content from "../../components/content"
import { Bar } from 'react-chartjs-2'
import SEO from "../../components/seo"

const TaxPage = ({ data }) => {
  let rates = data.graphAPI.taxRates
  let meta = data.graphAPI.contentTaxRate.meta
  let content = data.graphAPI.contentTaxRate.content
  return (
    <Layout>
      <SEO title={meta.title} />
      <div className="title-section">
        <h1 className="title is-size-1">{meta.title}</h1>
      </div>
      <div className="content-align">
        <div className="columns">
          <div className="column is-9">
            <p>Harris County MUD 449 Ad Valorem Taxes rates are based on property values established by the <a target="_blank" rel="noopener noreferrer" href="http://www.hcad.org/">Harris Central Appraisal District</a>. The tax rate (below) is per $100 of home value, as determined by the Harris Central Appraisal District.</p>
            <p><a class="button is-primary" href="https://www.taxtech.net/AccountSrch" target="_blank" rel="noopener noreferrer">View, Print, or Pay your Taxes Online</a></p>

            <p><a class="button is-primary" href="https://website-media-harris-co-mud-449.s3.amazonaws.com/2026_HC_MUD_449_QPA_Katy_Times_a815c2a1db.pdf" target="_blank" rel="noopener noreferrer">Notice of Public Hearing on Tax Rate 2026 - October 15, 2026</a></p>
          </div>
          <div className="column is-3">
            <p><strong className="is-size-5">Tax Assessor/Collector</strong></p>
            <p><strong>Tax Tech, Inc.</strong><br />
              Attn: Esther Flores</p>
            <p><strong>Mailing Address:</strong><br />
              12841 Capricorn St.<br />Stafford, Texas 77477</p>
            <p><strong>Phone:</strong><br />
              (281) 499-1223</p>
          </div>
        </div>
      </div>
      {/* <Content content={content} /> */}
      <div style={{ maxWidth: '600px' }}>
        <Bar data={{
          labels: rates.map((rate) => { return (rate.year) }).reverse(),
          datasets: [
            {
              label: "Debt Service",
              backgroundColor: "rgba(43,106,177,1)",
              strokeColor: "rgba(43,106,177,0.8)",
              highlightFill: "rgba(43,106,177,0.75)",
              highlightStroke: "rgba(43,106,177,1)",
              data: rates.map((rate) => { return (rate.interestSinkingRate.toFixed(4)) }).reverse()
            },
            {
              label: "Maintenance and Operation",
              backgroundColor: "rgba(43,106,177,0.5)",
              strokeColor: "rgba(43,106,177,0.8)",
              highlightFill: "rgba(43,106,177,0.75)",
              highlightStroke: "rgba(43,106,177,1)",
              data: rates.map((rate) => { return (rate.maintenanceOperationsRate.toFixed(4)) }).reverse()
            }
          ]
        }}
          options={{
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            tooltips: {
              mode: 'label',
              displayColors: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  var corporation = data.datasets[tooltipItem.datasetIndex].label;
                  var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                  var total = 0;
                  for (var i = 0; i < data.datasets.length; i++)
                    total += data.datasets[i].data[tooltipItem.index];
                  if (tooltipItem.datasetIndex != data.datasets.length - 1) {
                    //   return corporation + " : $" + valor.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    return corporation + " : $ " + valor;
                  } else {
                    return [corporation + " : $ " + valor];
                  }
                }
              }
            },
            scaleBeginAtZero: true
          }} width="600" height="400" />
      </div>
      <div className="content-align">
        <div className="table-container">
          <table className="table" style={{ marginTop: '3rem' }}>
            <thead>
              <tr>
                <td>Year</td>
                <td>Debt Service</td>
                <td>Maintenance</td>
                <td>Total Tax Rate</td>
                <td>Order Levying Taxes</td>
              </tr>
            </thead>
            <tbody>
              {rates.map(rate => (
                <tr key={rate.id}>
                  <td>{rate.year}</td>
                  <td>{(rate.interestSinkingRate).toFixed(4)}</td>
                  <td>{(rate.maintenanceOperationsRate).toFixed(4)}</td>
                  <td>{(rate.interestSinkingRate + rate.maintenanceOperationsRate + rate.roadRate).toFixed(4)}</td>
                  {rate.orderLevyingTaxes === null ? (<td></td>) : (<td><a className="button is-primary is-small" target="_blank" rel="noreferrer noopener" href={rate.orderLevyingTaxes.documentFile.publicURL}>Order Levying Taxes – {rate.year}</a></td>)}

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  )
}

export default TaxPage

export const query = graphql`
    query taxPageById {
        graphAPI {
            contentTaxRate {
                meta {
                    id
                    title
                    description
                }
                content {
                    ... on GRAPHAPI_ComponentPageBaseContent {
                        ...baseContent
                    }
                    ... on GRAPHAPI_ComponentPageImage {
                        ...pageImage
                    }
                    ... on GRAPHAPI_ComponentPageLinkCardWithImage {
                        ...linkCardWithImage
                    }
                    ... on GRAPHAPI_ComponentPageSplitContentImage {
                        ...splitContentImage
                    }
                    ... on GRAPHAPI_ComponentPageGallery {
                        ...pageGallery
                    }
                    ... on GRAPHAPI_ComponentPageLinkList {
                        ...pageLinkList
                    }
                }
            }
            taxRates(sort: "year:desc") {
                year
                maintenanceOperationsRate
                interestSinkingRate
                roadRate
                contractRate
                orderLevyingTaxes {
                    ...publicDocument
                }
            }
        } 
    }
`


